import {
    GameEvent,
    isPlayerAction,
    isRemovePlayerEvent,
    PlayerId,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import {AvatarInterface, defaultAvatar} from '../hooks/usePlayerAvatars';
import {isPlayerAvatarPayload} from '../SignlinesPayloadTypes';


interface AvatarMap {
    [key: PlayerId]: AvatarInterface
}

export interface AvatarSlice extends SharedGameState {
    playerAvatars?: AvatarMap;
}

export const avatarProjection: Projection<AvatarSlice> = {
    name: 'avatarProjection',
    project: (
        state: AvatarSlice,
        newEvents: GameEvent[],
    ): Partial<AvatarSlice> => {

        const playerAvatars: AvatarMap = {...(state.playerAvatars ?? {})};
        let modified = false;

        newEvents.forEach(ev => {
            if (isPlayerAction(ev) && isPlayerAvatarPayload(ev.payload)) {
                const playerId = ev.playerId;
                if (!playerId) throw new Error('Avatar event missing playerId');
                playerAvatars[playerId] = (ev.payload).avatar;
                modified = true;
            } else if (isRemovePlayerEvent(ev)) {
                const removedId = ev.removePlayerId;
                if (removedId && playerAvatars[removedId] !== undefined) {
                    delete playerAvatars[removedId];
                    modified = true;
                }
            }
        });

        return modified ? {playerAvatars} : {};
    },
    reset: () => ({playerAvatars: {}}),
};

export const usePlayerAvatar = (playerId: PlayerId) => {
    const avatarSlice = useGameStore((s: AvatarSlice) => s.playerAvatars) ?? {};
    return (avatarSlice[playerId]) ?? defaultAvatar;
};
